import {MissionIdentifier} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/mission.types';
import {ClaimMissionRewardResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useMemo} from 'react';

const COINS_CLAIM_POPUP_KEY = 'COINS_CLAIM_POPUP';

export type CoinsClaimPopupData = {
  result: NonNullable<ClaimMissionRewardResponse['result']>;
  missionIdentifier: MissionIdentifier;
};

export const useOpenCoinsClaimPopup = (): {
  cancel: () => void;
  isOpen: boolean;
  open: (params: {
    claimResponse: ClaimMissionRewardResponse;
    missionIdentifier: MissionIdentifier;
  }) => void;
  coinsData: CoinsClaimPopupData | null;
} => {
  const {
    cancel,
    isOpen,
    open: baseOpen,
    parameter: baseParameter,
  } = useOpenedStateManager(COINS_CLAIM_POPUP_KEY);

  const open = ({
    claimResponse,
    missionIdentifier,
  }: {
    claimResponse: ClaimMissionRewardResponse;
    missionIdentifier: MissionIdentifier;
  }) => {
    if (!claimResponse.result) {
      return;
    }

    baseOpen({
      parameter: JSON.stringify({
        result: claimResponse.result,
        missionIdentifier,
      } satisfies CoinsClaimPopupData),
    });
  };

  const parameter: CoinsClaimPopupData | null = useMemo(() => {
    if (!baseParameter) {
      return null;
    }

    return JSON.parse(baseParameter);
  }, [baseParameter]);

  return {
    cancel,
    isOpen,
    open,
    coinsData: parameter,
  };
};
